import React from "react";
import { FaCalendarCheck, FaCalendarTimes, FaFilter, FaMapMarkerAlt } from "react-icons/fa";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-sky-700 shadow-sm dark:bg-white/10 dark:text-sky-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>
          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function SharedEventsStats({ stats }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        icon={FaCalendarCheck}
        label="Événements à venir"
        value={stats.upcoming}
        description="Encore disponibles à copier"
      />

      <StatCard
        icon={FaCalendarTimes}
        label="Événements passés"
        value={stats.past}
        description="Historique consultable"
      />

      <StatCard
        icon={FaMapMarkerAlt}
        label="Départements actifs"
        value={stats.departmentsCount}
        description="Avec au moins un événement"
      />

      <StatCard
        icon={FaFilter}
        label="Types différents"
        value={stats.typesCount}
        description="Stages, compétitions, animations..."
      />
    </div>
  );
}

export default SharedEventsStats;